/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateNaturalPersonCommandDto } from './CreateNaturalPersonCommandDto';
import {
    CreateNaturalPersonCommandDtoFromJSON,
    CreateNaturalPersonCommandDtoFromJSONTyped,
    CreateNaturalPersonCommandDtoToJSON,
    CreateNaturalPersonCommandDtoToJSONTyped,
} from './CreateNaturalPersonCommandDto';
import type { CreateLegalEntityCommandDto } from './CreateLegalEntityCommandDto';
import {
    CreateLegalEntityCommandDtoFromJSON,
    CreateLegalEntityCommandDtoFromJSONTyped,
    CreateLegalEntityCommandDtoToJSON,
    CreateLegalEntityCommandDtoToJSONTyped,
} from './CreateLegalEntityCommandDto';

/**
 * 
 * @export
 * @interface CreateInsuredPersonCommandDto
 */
export interface CreateInsuredPersonCommandDto {
    /**
     * 
     * @type {CreateNaturalPersonCommandDto}
     * @memberof CreateInsuredPersonCommandDto
     */
    naturalPerson?: CreateNaturalPersonCommandDto;
    /**
     * 
     * @type {CreateLegalEntityCommandDto}
     * @memberof CreateInsuredPersonCommandDto
     */
    legalEntity?: CreateLegalEntityCommandDto;
    /**
     * 
     * @type {string}
     * @memberof CreateInsuredPersonCommandDto
     */
    riskId?: string;
}

/**
 * Check if a given object implements the CreateInsuredPersonCommandDto interface.
 */
export function instanceOfCreateInsuredPersonCommandDto(value: object): value is CreateInsuredPersonCommandDto {
    return true;
}

export function CreateInsuredPersonCommandDtoFromJSON(json: any): CreateInsuredPersonCommandDto {
    return CreateInsuredPersonCommandDtoFromJSONTyped(json, false);
}

export function CreateInsuredPersonCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateInsuredPersonCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'naturalPerson': json['naturalPerson'] == null ? undefined : CreateNaturalPersonCommandDtoFromJSON(json['naturalPerson']),
        'legalEntity': json['legalEntity'] == null ? undefined : CreateLegalEntityCommandDtoFromJSON(json['legalEntity']),
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
    };
}

export function CreateInsuredPersonCommandDtoToJSON(json: any): CreateInsuredPersonCommandDto {
    return CreateInsuredPersonCommandDtoToJSONTyped(json, false);
}

export function CreateInsuredPersonCommandDtoToJSONTyped(value?: CreateInsuredPersonCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'naturalPerson': CreateNaturalPersonCommandDtoToJSON(value['naturalPerson']),
        'legalEntity': CreateLegalEntityCommandDtoToJSON(value['legalEntity']),
        'riskId': value['riskId'],
    };
}

